import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Image from '@client/components/image/Image';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import ReactLink from '@client/components/reactLink/ReactLink';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import {
  getImageOrDefault,
  fakeEllipsis,
} from '@client/shared/utils/utils/utils';
import FundraiserCardTargetsBox from '@client/containers/fundraiserCardTargetsBox/FundraiserCardTargetsBox';
import {
  isMemorialFundraiser,
  remapFundraiserTypeName,
} from '@client/shared/utils/fundraiserUtils/fundraiserUtils';
import styles from './fundraiserCard.scss';

class FundraiserCard extends PureComponent {
  getFundraiserUrl = (fundraiserType, slug) => {
    if (isMemorialFundraiser(fundraiserType)) {
      return `/minnesfonder/${slug}`;
    } else {
      return `/insamling/${slug}`;
    }
  };

  render() {
    const {
      className,
      fundraiser,
      fluidImage,
      showStatsInsteadOfDescription,
      defaultDescriptionText,
    } = this.props;

    const link = this.getFundraiserUrl(
      getIn(fundraiser, 'fundraiserType'),
      getIn(fundraiser, 'slug')
    );

    return (
      <ReactLink
        to={link}
        className={`${styles.fundraiserCard}${
          className ? ` ${className}` : ''
        }`}
        target={'_self'}
      >
        <div className={!fluidImage ? styles.imageContainerCenter : ''}>
          <span className={styles.fundraiserTypeLabel}>
            {remapFundraiserTypeName(getIn(fundraiser, 'fundraiserType'))}
          </span>
          <Image
            className={
              !fluidImage ? styles.fundraiserCardImage : styleHelper.imageFluid
            }
            src={getImageOrDefault(getIn(fundraiser, 'imageUrl'))}
          />
        </div>
        <div className={styles.contentContainer}>
          <h3 className={`${styleHelper.titleSmPrimary} ${styles.cardTitle}`}>
            {fakeEllipsis(getIn(fundraiser, 'title', 100))}
          </h3>
          {showStatsInsteadOfDescription ? (
            <>
              <p
                className={`${styleHelper.breadTextPrimary} ${styles.cardStats}`}
              >
                Startade {getIn(fundraiser, 'created').slice(0, 10)}
              </p>
              <FundraiserCardTargetsBox
                largeFont={false}
                fullWidthProgressBar={true}
                amountDonated={getIn(fundraiser, 'amountDonated')}
                targetAmount={getIn(fundraiser, 'targetAmount')}
                showDonatedSoFarLabel={false}
              />
            </>
          ) : (
            <p
              className={`${styleHelper.breadTextPrimary} ${styles.cardDescription}`}
              suppressHydrationWarning={true}
            >
              {getIn(fundraiser, 'description') || defaultDescriptionText}
            </p>
          )}
        </div>
      </ReactLink>
    );
  }
}

FundraiserCard.propTypes = {
  className: PropTypes.string,
  fluidImage: PropTypes.bool,
  showStatsInsteadOfDescription: PropTypes.bool,
  defaultDescriptionText: PropTypes.string,
  fundraiser: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string,
    description: PropTypes.string,
    targetAmount: PropTypes.number,
    amountDonated: PropTypes.number,
    imageUrl: PropTypes.string,
    creator: ImmutablePropTypes.mapContains({
      firstName: PropTypes.string,
    }),
    otherFundraisers: ImmutablePropTypes.list,
  }),
};

export default FundraiserCard;
